import request from '@/http'


//c仓单企业经营概况-查询企业仓库货区
export function queryEnterpriseStorehouseList(params) {

    return request({
        url: 'ffsapp-service/superviseProperty/queryEnterpriseStorehouseList',
        method: 'post',
        data: params
    })
}
//仓单企业经营概况-企业库存
export function queryEnterpriseInventoryStatistics(params) {

    return request({
        url: 'ffsapp-service/superviseProperty/queryEnterpriseInventoryStatistics',
        method: 'post',
        data: params
    })
}

//仓单企业经营概况-根据货区查企业库存
export function queryEnterpriseInventoryByPositionIdStatistics(params) {

    return request({
        url: 'ffsapp-service/superviseProperty/queryEnterpriseInventoryByPositionIdStatistics',
        method: 'post',
        data: params
    })
}
//仓单企业经营概况-出入库货值统计
export function queryEnterpriseInventoryPriceStatistics(params) {

    return request({
        url: 'ffsapp-service/superviseProperty/queryEnterpriseInventoryPriceStatistics',
        method: 'post',
        data: params
    })
}
//仓单企业经营概况-销售渠道分布
export function queryEnterpriseInventorySaleDetailStatistics(params) {

    return request({
        url: 'ffsapp-service/superviseProperty/queryEnterpriseInventorySaleDetailStatistics',
        method: 'post',
        data: params
    })
}
//仓单企业经营概况-出入库货值统计
export function queryEnterpriseInventorySaleStatistics(params) {

    return request({
        url: 'ffsapp-service/superviseProperty/queryEnterpriseInventorySaleStatistics',
        method: 'post',
        data: params
    })
}